import React from "react";
import styles from "./css/ChatSmall.module.css";

const ChatSmall = ({
  name,
  lastMessage,
  lastMessageTime,
  id,
  openChat,
  userId,
  active,
  profilePic,
  profile_id,
  handleProfilenavigation,
}) => {
  // Simplified and consistent profile picture URL handling
  const getProfilePicUrl = (profilePic) => {
    console.log('ChatSmall - Raw profilePic:', profilePic);
    
    // Return default avatar if no profile pic is provided
    if (!profilePic || profilePic === "" || profilePic === null || profilePic === undefined) {
      console.log('ChatSmall - Using default avatar (no pic provided)');
      return "/Image/header/ddefault_img.svg";
    }
    
    // If it's already a full URL (starts with http:// or https://), return as is
    if (profilePic.startsWith('http://') || profilePic.startsWith('https://')) {
      console.log('ChatSmall - Using full URL:', profilePic);
      return profilePic;
    }
    
    // If it's already a local path starting with '/Image/', return as is
    if (profilePic.startsWith('/Image/')) {
      console.log('ChatSmall - Using local path:', profilePic);
      return profilePic;
    }
    
    // If it's the default avatar name, use the correct path
    if (profilePic === "ddefault_img.svg" || profilePic.includes("default")) {
      console.log('ChatSmall - Using default avatar (name detected)');
      return "/Image/header/ddefault_img.svg";
    }
    
    // For API-based profile pics, construct the full URL
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    if (baseUrl) {
      const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
      const cleanProfilePic = profilePic.startsWith('/') ? profilePic : `/${profilePic}`;
      const finalUrl = `${cleanBaseUrl}${cleanProfilePic}`;
      console.log('ChatSmall - Using API URL:', finalUrl);
      return finalUrl;
    }
    
    // Fallback to default if we can't construct a proper URL
    console.log('ChatSmall - Fallback to default avatar');
    return "/Image/header/ddefault_img.svg";
  };

  const imageUrl = getProfilePicUrl(profilePic);

  return (
    <div onClick={() => openChat(id)} className={styles.container}>
      <div
        className={
          active ? styles.innerContainerClicked : styles.innerContainer
        }
      >
        <div
          className={styles.profilePicContainer}
          onClick={(e) => {
            e.stopPropagation(); // Prevents triggering openChat
            handleProfilenavigation(profile_id);
          }}
        >
          <img className={styles.profilePic} src={imageUrl} alt="profile" />
        </div>
        <div className={styles.nameContainer}>
          <div className={styles.innerNameContainer}>
            <span className={styles.name}>{name}</span>
            {lastMessage && (
              <span className={styles.lastMessage}>{lastMessage}</span>
            )}
          </div>
          <div className={styles.dateContainer}>{lastMessageTime}</div>
        </div>
      </div>
    </div>
  );
};

export default ChatSmall;